var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "user_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".user_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.7,
    r: 5.5,
    className: "user_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.7c0-5 4-9 9-9s9 4 9 9z",
    className: "user_svg__st0"
  })));
};
export default SvgUser;